var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "folderTreeSelect", staticClass: "folder-tree-select" },
    [
      _c(
        "div",
        {
          ref: "trigger",
          staticClass: "folder-tree-select__trigger",
          class: {
            "folder-tree-select__trigger--selected": _vm.hasSelection,
            "folder-tree-select__trigger--opened": _vm.isVisible,
          },
          attrs: { role: "button", tabindex: "0" },
          on: {
            click: _vm.handleToggleDropdown,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                return _vm.handleToggleDropdown.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                )
                  return null
                $event.preventDefault()
                return _vm.handleToggleDropdown.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape",
                  ])
                )
                  return null
                return _vm.closeDropdown.apply(null, arguments)
              },
            ],
          },
        },
        [
          _c("b-icon", { attrs: { icon: "folder" } }),
          _vm._v(" "),
          _c("span", { staticClass: "folder-tree-select__trigger-label" }, [
            _vm._v(_vm._s(_vm.triggerLabel)),
          ]),
          _vm._v(" "),
          _vm.hasSelection
            ? _c(
                "button",
                {
                  staticClass: "folder-tree-select__remove",
                  attrs: {
                    type: "button",
                    "aria-label": "Remove folder selection",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleRemove.apply(null, arguments)
                    },
                  },
                },
                [_c("b-icon", { attrs: { icon: "x" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-icon", {
            staticClass: "folder-tree-select__chevron",
            attrs: { icon: "chevron-down" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "dropdown",
          staticClass: "folder-tree-select__dropdown",
          class: { "folder-tree-select__dropdown--opened": _vm.isVisible },
          on: {
            mousedown: function ($event) {
              $event.stopPropagation()
            },
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "folder-tree-select__search" },
            [
              _c("b-icon", { attrs: { icon: "search" } }),
              _vm._v(" "),
              _c("b-form-input", {
                ref: "searchInput",
                attrs: {
                  placeholder: "Search folders...",
                  autocomplete: "off",
                },
                on: {
                  input: _vm.handleSearchFolder,
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape",
                      ])
                    )
                      return null
                    return _vm.closeDropdown.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.searchValue,
                  callback: function ($$v) {
                    _vm.searchValue = $$v
                  },
                  expression: "searchValue",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "folder-tree-select__root-label" },
            [
              _c("b-icon", { attrs: { icon: "house" } }),
              _vm._v(" "),
              _c("span", [_vm._v("Files")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "folder-tree-select__list" },
            [
              !_vm.folders
                ? [_vm._m(0)]
                : _vm.folders.length
                ? _vm._l(_vm.folders, function (folder) {
                    return _c("FolderTreeSelectItem", {
                      key: folder.id,
                      attrs: { item: folder, selected: _vm.pendingFolder },
                      on: { change: _vm.handleFolderChange },
                    })
                  })
                : [
                    _c("div", { staticClass: "folder-tree-select__status" }, [
                      _vm._v("\n          No folders found.\n        "),
                    ]),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _vm.isCreatingFolder
            ? _c(
                "div",
                { staticClass: "folder-tree-select__new-folder-form" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.draftFolderName,
                        expression: "draftFolderName",
                      },
                    ],
                    ref: "newFolderInput",
                    staticClass:
                      "form-control folder-tree-select__new-folder-input",
                    attrs: {
                      type: "text",
                      placeholder: "New folder name",
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.draftFolderName },
                    on: {
                      mousedown: function ($event) {
                        $event.stopPropagation()
                      },
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.createFolder.apply(null, arguments)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape",
                            ])
                          )
                            return null
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.cancelCreateFolder.apply(null, arguments)
                        },
                      ],
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.draftFolderName = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "folder-tree-select__create-button",
                      attrs: {
                        type: "button",
                        disabled: !_vm.draftFolderName.trim(),
                      },
                      on: { click: _vm.createFolder },
                    },
                    [_vm._v("\n        Create\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "folder-tree-select__cancel-button",
                      attrs: { type: "button" },
                      on: { click: _vm.cancelCreateFolder },
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                ]
              )
            : _c("div", { staticClass: "folder-tree-select__footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "folder-tree-select__new-folder-button",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.startCreateFolder.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("b-icon", { attrs: { icon: "folder-plus" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v("New folder")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "folder-tree-select__use-button",
                    attrs: { type: "button", disabled: !_vm.pendingFolder },
                    on: { click: _vm.useSelectedFolder },
                  },
                  [_vm._v("\n        Use this folder\n      ")]
                ),
              ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "folder-tree-select__status" }, [
      _c("span", {
        staticClass: "spinner-border spinner-border-sm",
        attrs: { role: "status", "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }